<template>
    <div class="card_body">
        <div class="card_title">
            {{ $t('agent.graphCardTitle')}}
        </div>
        <img src="@/assets/agent/afiliado_3.png" alt="">
        <div class="note_text" v-if="props.isShowNotice">
             {{ $t('agent.graphCardContent1')}}<span>{{ $t('agent.graphCardContent2')}}</span><br>
            {{ $t('agent.graphCardContent3')}}
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
    isShowNotice: {
        type: Boolean,
        default: () => false
    }
})
</script>
<style scoped>
.card_body {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
}

.card_title {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    padding: 15px 15px 0;
    display: flex;
    justify-content: center;
    text-align: center;
}

.card_body img {
    width: 100%;
}

.note_text {
    padding: 0 15px 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.85);
}

.note_text span {
    color: #FFEE00;
    padding: 0 5px;
}
</style>